import {
    getData,
    postData,
    patchData,
    deleteData
} from './Services'

export const getAccionesRolesLista = async () => {
    const res = await getData('/rolesacciones');
    return res
}
 
export const postAccionRol = async (body) => {
    const res = await postData('/rolesacciones', body)
    return res
}

export const patchAccionRol = async (id, body) => {
    const res = await patchData(`/rolesacciones/${id}`, body)
    return res
}

export const deleteAccionRol = async (id) => {
    const res = await deleteData(`/rolesacciones/${id}`)
    return res
}